import { useState } from "react";
interface initStateType {
  searchValue: string | undefined;
}
const initState: initStateType = {
  searchValue: "",
};

export default () => {
  const [state, setState] = useState(initState);
  return {
    ...state,
    setState,
  };
};
